import { buildCreateSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductStateType } from '@screens/Product/model/types/productState';

const createAppSlice = buildCreateSlice();

const initialState: ProductStateType = {
  data: {
    id: '',
    name: '',
    sku: '',
    translitName: '',
    props: {},
    retailPrice: 0
  }
};

export const productSlice = createAppSlice({
  name: 'product',
  initialState,
  reducers: (create) => ({
    initState: create.reducer((state, action: PayloadAction<ProductStateType>) => {
      state.data = action.payload.data;
    })
  })
});

export const { initState } = productSlice.actions;

export const productReducer = productSlice.reducer;
